
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class LoadingSpinner extends Vue {
  @Prop({ default: '1.5em' }) size!: string
}
